module.exports = __webpack_public_path__ + "img/collection-weddingRingsCertificate@2x.8e1ea56.jpg";